import { useQuery } from '@tanstack/react-query';

import { useApi } from '../api-context';
import { queryKeys } from '../query-keys';
import { adminOverviewSchema, type AdminOverview } from '../schemas';
import { useToken } from './use-token';

/** Tableau de bord du back-office : relu chaque minute, il sert à repérer un incident. */
export function useAdminOverview(days = 30) {
  const api = useApi();
  const token = useToken();

  return useQuery({
    queryKey: queryKeys.adminOverview.byDays(days),
    queryFn: () =>
      api.get<AdminOverview>(`/admin/overview?days=${days}`, { schema: adminOverviewSchema }),
    enabled: token !== null,
    refetchInterval: 60_000,
  });
}
